import { api } from "./http-client";
import {
  Notification,
  NotificationListResponse,
  TestPushListingOption,
} from "../types/notification";

export const notificationsService = {
  async listAdmin(options?: {
    page?: number;
    take?: number;
    isRead?: boolean;
  }): Promise<NotificationListResponse> {
    const response = await api.request<NotificationListResponse>({
      url: "/notifications/admin",
      method: "GET",
      params: options,
    });
    return response.data;
  },
  async markAdminRead(id: string): Promise<Notification> {
    const response = await api.request<Notification>({
      url: `/notifications/admin/${id}/read`,
      method: "PATCH",
    });
    return response.data;
  },
  async listUser(options?: {
    page?: number;
    take?: number;
    isRead?: boolean;
  }): Promise<NotificationListResponse> {
    const response = await api.request<NotificationListResponse>({
      url: "/notifications/user",
      method: "GET",
      params: options,
    });
    return response.data;
  },
  async markUserRead(id: string): Promise<Notification> {
    const response = await api.request<Notification>({
      url: `/notifications/user/${id}/read`,
      method: "PATCH",
    });
    return response.data;
  },
  async listSent(options?: {
    page?: number;
    take?: number;
  }): Promise<NotificationListResponse> {
    const response = await api.request<NotificationListResponse>({
      url: "/notifications/admin/sent",
      method: "GET",
      params: options,
    });
    return response.data;
  },
  async sendUser(data: {
    userId?: string;
    userIds?: string[];
    isBroadcast?: boolean;
    title: string;
    message: string;
    category?: string;
  }): Promise<Notification[]> {
    const response = await api.request<Notification[]>({
      url: "/notifications/user/send",
      method: "POST",
      data,
    });
    return response.data;
  },
  async listTestSavedSearchListings(): Promise<TestPushListingOption[]> {
    const response = await api.request<TestPushListingOption[]>({
      url: "/notifications/test/saved-search/listings",
      method: "GET",
    });
    return response.data;
  },
  async sendTestSavedSearch(data: {
    userId: string;
    listingId: string;
    searchName?: string;
  }): Promise<Notification> {
    const response = await api.request<Notification>({
      url: "/notifications/test/saved-search",
      method: "POST",
      data,
    });
    return response.data;
  },
};
